// extracted by mini-css-extract-plugin
export default {"link":"FileLink_link__x3r8N","link_preview":"FileLink_link_preview__jw8Fo"};